import { ReactNode } from 'react';

export interface TabItem<K extends string = string> {
  key: K;
  label: ReactNode;
  count?: number | string;
  kbd?: string;
}

export interface TabsProps<K extends string = string> {
  items: TabItem<K>[];
  value: K;
  onChange: (key: K) => void;
  underline?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export function Tabs<K extends string = string>({
  items,
  value,
  onChange,
  underline = true,
  style,
  className = '',
}: TabsProps<K>) {
  const classes = [
    'ds-tabs',
    underline ? '' : 'ds-tabs-bare',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} style={style} role="tablist">
      {items.map((t) => {
        const active = t.key === value;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            className={`ds-tab ${active ? 'ds-tab-active' : ''}`}
            onClick={() => onChange(t.key)}
          >
            <span>{t.label}</span>
            {t.count != null ? <span className="ds-tab-count">{t.count}</span> : null}
            {t.kbd ? <span className="ds-kbd ds-tab-kbd">{t.kbd}</span> : null}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
